export const generateQueryParams = (filters) => {
  const queryParams = new URLSearchParams();
  const params = new URLSearchParams();

  filters.forEach(({ searchKey, searchValue, isQueryParam }) => {
    if (isQueryParam) {
      // queryParams.append(searchKey, searchValue);
      //   searchKey: 'createdTime',
      // searchValue: {
      //   'createdTime[gte]': '2025-03-12',
      //   'createdTime[lte]': '2025-03-14'
      // }

      if (typeof searchValue == "object") {
        Object.keys(searchValue).forEach((key) => {
          queryParams.append(`${key}`, searchValue[key]);
        });
      } else {
        // queryParams.append(searchKey, searchValue);
        params.append("filterKey", searchKey);
        params.append("filterValues", searchValue);
      }
    } else {
      params.append("searchKey", searchKey);
      params.append("searchValue", searchValue);
    }
  });

  return { queryParams, params };
};
